"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useOverlayBgStyles;
var _Settings = _interopRequireDefault(require("../../../layouts/default/Settings"));
var _helpers = require("../../../layouts/default/helpers");
var _Settings2 = _interopRequireDefault(require("../../../layouts/upload/Settings"));
var _helpers2 = require("../../../layouts/upload/helpers");
var _style = _interopRequireDefault(require("../../../layouts/birds/style.css"));
var _style2 = _interopRequireDefault(require("../../../layouts/geometric/style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function useOverlayBgStyles() {
  var layout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isShowingLayoutBgColor = arguments.length > 1 ? arguments[1] : undefined;
  switch (layout.handle) {
    case 'default':
      return {
        style: (0, _helpers.getBgStyle)(_objectSpread(_objectSpread({}, _Settings["default"]), layout.settings), isShowingLayoutBgColor)
      };
    case 'upload':
      return {
        style: (0, _helpers2.getBgStyles)(_objectSpread(_objectSpread({}, _Settings2["default"]), layout.settings), isShowingLayoutBgColor)
      };
    case 'hhlBirds':
      return {
        className: _style["default"].show
      };
    case 'geometric':
      return {
        className: _style2["default"].show
      };
    default:
      return {};
  }
}